
import React, { useEffect, useState } from 'react';
import MarqueeBar from '../MarqueeBar';
import { getWeeklyParasha } from '@/utils/pageUtils';

const MarqueeBarContainer: React.FC = () => {
  const [weeklyParasha, setWeeklyParasha] = useState<string>('טוען...');
  const [parashaKey, setParashaKey] = useState<string>('');

  // Fetch weekly parasha on component mount and update when week changes
  useEffect(() => {
    let isMounted = true;
    
    const fetchParasha = async () => {
      console.log('Fetching weekly parasha...');
      try {
        // Force fresh calculation by clearing cache first
        localStorage.removeItem('weekly_parasha_cache');
        
        const parasha = await getWeeklyParasha();
        console.log('Fetched parasha:', parasha);
        if (isMounted) {
          setWeeklyParasha(parasha);
          setParashaKey(parasha); // Use parasha name as key
        }
      } catch (error) {
        console.error('Error in fetchParasha:', error);
        if (isMounted) {
          setWeeklyParasha('שגיאה בטעינת פרשת השבוע');
        }
      }
    };
    
    fetchParasha();

    // Set up interval to check for parsha change every hour
    // This is more efficient than checking every minute
    const interval = setInterval(async () => {
      try {
        const newParasha = await getWeeklyParasha();
        console.log('Checking for parasha update:', newParasha);
        if (newParasha !== parashaKey && isMounted) {
          setWeeklyParasha(newParasha);
          setParashaKey(newParasha);
        }
      } catch (error) {
        console.error('Error in parasha interval check:', error);
      }
    }, 60 * 60 * 1000); // every hour

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [parashaKey]);

  // Add a manual refresh function that can be called
  const refreshParasha = async () => {
    console.log('Manual parasha refresh triggered');
    localStorage.removeItem('weekly_parasha_cache');
    try {
      const parasha = await getWeeklyParasha();
      setWeeklyParasha(parasha);
      setParashaKey(parasha);
    } catch (error) {
      console.error('Error in manual parasha refresh:', error);
    }
  };

  // Add click handler for debugging
  const handleParashaClick = () => {
    console.log('Parasha clicked - triggering refresh');
    refreshParasha();
  };

  return (
    <div onClick={handleParashaClick} style={{ cursor: 'pointer' }}>
      <MarqueeBar parashaText={weeklyParasha} />
    </div>
  );
};

export default MarqueeBarContainer;
